export type MobileLayoutLanguage = 'it' | 'en' | 'zh'

export const MOBILE_LAYOUT_MESSAGES = Object.freeze({
  it: Object.freeze({ closePanels: 'Chiudi pannelli', workspaceNavigation: 'Navigazione area di lavoro e sessioni' }),
  en: Object.freeze({ closePanels: 'Close panels', workspaceNavigation: 'Workspace and session navigation' }),
  zh: Object.freeze({ closePanels: '关闭浮层', workspaceNavigation: '工作区与会话导航' }),
})
